import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

/**
 * Single place for “use kiln-list (desktop split view) vs landing (swiper)”.
 * Matches kiln-list layout breakpoints and post-login routing on home.
 */
@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private static readonly MIN_SPLIT_WIDTH = 875;
  private static readonly DESKTOP_KILN_LIST_MIN_WIDTH = 1024;

  constructor(private platform: Platform) {}

  private isHandheldDevice(): boolean {
    return this.platform.is('mobile')
      || this.platform.is('tablet')
      || this.platform.is('phablet')
      || this.platform.is('mobileweb');
  }

  /** True when navigation should target kiln-list instead of landing. */
  shouldUseKilnListRoute(): boolean {
    const width = this.platform.width();

    if (this.platform.is('tablet')) {
      return this.platform.isLandscape() && width >= ViewportService.MIN_SPLIT_WIDTH;
    }

    if (this.platform.is('desktop') && !this.isHandheldDevice()) {
      return width > ViewportService.DESKTOP_KILN_LIST_MIN_WIDTH;
    }

    return width > ViewportService.DESKTOP_KILN_LIST_MIN_WIDTH;
  }

  /** Matches kiln-list `small_screen` on phones and tablets. */
  usesMobileKilnLayout(): boolean {
    if (!this.isHandheldDevice() || this.platform.is('desktop')) {
      return false;
    }

    const width = this.platform.width();
    if (this.platform.is('tablet')) {
      return !this.platform.isLandscape() || width < ViewportService.MIN_SPLIT_WIDTH;
    }

    return this.platform.isLandscape() || width < ViewportService.MIN_SPLIT_WIDTH;
  }

  /** iPad/tablet orientation changes swap between landing and kiln-list. */
  usesTabletOrientationRouting(): boolean {
    return this.platform.is('tablet');
  }
}
